import { render } from "./InstanceCard.vue?vue&type=template&id=c37b7832&scoped=true&ts=true"
import script from "./InstanceCard.vue?vue&type=script&lang=ts"
export * from "./InstanceCard.vue?vue&type=script&lang=ts"

import "./InstanceCard.vue?vue&type=style&index=0&id=c37b7832&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37b7832"]])

export default __exports__